<template>
  <div class="tooltip" ref="tooltipContainer">
    <Teleport to="body">
      <div
        ref="tooltip"
        class="tooltip__container"
        :class="[customClass, { 'is-active': isShow }]"
        :style="`top: ${coords.top}px; left: ${coords.left}px`">

        <atomic-image :src="tooltipArrow" />
        <div class="tooltip__content" v-if="props.text">
          {{ text }}
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      text?: string;
      customClass?: string;
      offset?: number;
      parent?: HTMLElement;
    }>(),
    {
      offset: 15,
    },
  );

  const colorMode = useColorMode();

  const coords = reactive({
    top: 0,
    left: 0,
  });

  const tooltip = ref<HTMLElement>();
  const tooltipContainer = ref<HTMLElement>();
  const isShow = ref(false);

  const tooltipArrow = computed(() => {
    return `/img/tooltip-arrow-left-${colorMode.value}.svg`;
  });

  const setCoords = () => {
    const pRect = tooltipContainer.value?.getBoundingClientRect();
    const tRect = tooltip.value?.getBoundingClientRect();

    if (pRect && tRect) {
      coords.left = pRect.x + pRect.width + props.offset;
      coords.top = pRect.y + pRect.height / 2 - tRect.height / 2;
    }
  };

  const show = () => {
    setCoords();
    isShow.value = true;
  };

  const hide = () => {
    isShow.value = false;
    coords.left = -100;
    coords.top = -100;
  };

  defineExpose({ show, hide });
</script>

<style src="~/assets/styles/components/atomic/tooltip.scss" lang="scss" />
